export const REDIRECT_URI_PATHNAME = '/_oauth2/callback';
export const OAUTH_COOKIE_NAME = 'plotly_oauth_token'
